var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ImportJobSource, ImportJobStatus } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import FSButton from '@components/FSButton';
import Manager from '@shared/modal/Manager';
import SearchInput from '@shared/input/SearchInput';
import { Confirmation as ConfirmationModal } from '@shared/modal/Simple';
import CheckboxMenu from '@shared/input/CheckboxMenu';
import * as FarseerIcons from '@shared/icons/icons';
import { useUsers } from '@data/hooks/usersAndGroups';
import { useDeleteImportJob, useDetectDimensions, useImportJobs, useUpdateImportJob, } from '@data/importJob/importJobActions';
//@ts-ignore
import ExcelIcon from '!url-loader!../../assets/images/greenexcel.png';
import { ImportJobStatusLabel, statusMessageMap } from './ImportJobStatusLabel';
import ImportActionsMenu from './ImportActionsMenu';
import { downloadFarseerFile, globalLoadingWrapped } from './util';
export default function ImportJobsList() {
    var _a;
    var _this = this;
    var _b;
    var _c = useLanguage(), L = _c.L, formatLocaleDate = _c.formatLocaleDate;
    var navigate = useNavigate();
    var importJobs = (_b = useImportJobs().data) !== null && _b !== void 0 ? _b : [];
    var updateImportJob = useUpdateImportJob();
    var deleteImportJob = useDeleteImportJob();
    var detectDimensions = useDetectDimensions();
    var users = useUsers();
    var _d = __read(useState(''), 2), searchString = _d[0], setSearchString = _d[1];
    var _e = __read(useState((_a = {},
        _a[ImportJobStatus.CREATED] = true,
        _a[ImportJobStatus.COMMITED] = true,
        _a[ImportJobStatus.REVERTED] = true,
        _a[ImportJobStatus.ARCHIVED] = false,
        _a)), 2), shownStatuses = _e[0], setShownStatuses = _e[1];
    var openImportJob = function (importJob) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    navigate("/import/job/".concat(importJob.id));
                    if (!(importJob.status === ImportJobStatus.CREATED || importJob.status === ImportJobStatus.REVERTED)) return [3 /*break*/, 2];
                    return [4 /*yield*/, detectDimensions.mutateAsync(importJob.id)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var deleteImportJobHandler = function (importJobId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () { return deleteImportJob.mutateAsync(importJobId); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var openDeleteModal = function (importJob) {
        Manager.renderModal(React.createElement(ConfirmationModal, { width: 500, title: L('Confirm'), onOk: function () { return deleteImportJobHandler(importJob.id); } },
            React.createElement("span", null,
                L('Are you sure you want to delete'),
                " ",
                React.createElement("b", null, importJob.title),
                ' ?')));
    };
    var archiveImportJob = function (importJobId) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, globalLoadingWrapped(function () {
                        return updateImportJob.mutateAsync({ id: importJobId, status: ImportJobStatus.ARCHIVED });
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var replaceImportJob = function (jobId) {
        navigate("/import/replace/".concat(jobId));
    };
    function filterFunction(importJob) {
        if (searchString !== '') {
            var includesTitleFilter = importJob.title.toLowerCase().includes(searchString.toLowerCase());
            if (!includesTitleFilter) {
                return false;
            }
        }
        if (!shownStatuses[importJob.status]) {
            return false;
        }
        return true;
    }
    var filteredSortedImportJobs = importJobs.filter(filterFunction).sort(function (a, b) { return a.title.localeCompare(b.title); });
    return (React.createElement("div", { className: "fs-import-container" },
        React.createElement("div", { className: "previous-imports-toolbar" },
            React.createElement("h3", { className: "previous-imports-title" }, L('Previous Imports')),
            React.createElement(FSButton, { "$type": "primary", "$color": "primary", title: L('New Import'), onClick: function () { return navigate('/import'); } })),
        React.createElement("div", { className: "previous-imports-filters" },
            React.createElement(SearchInput, { name: "search", placeholder: L('Search for imports'), value: searchString, onChange: function (e) { return setSearchString(e.target.value); }, css: { minWidth: '300px', flexGrow: 0 } }),
            React.createElement(CheckboxMenu, { title: L('Status'), items: Object.keys(shownStatuses).map(function (status) { return ({
                    label: L(statusMessageMap[status]),
                    checked: shownStatuses[status],
                    onToggle: function (newShownValue) {
                        var _a;
                        setShownStatuses(__assign(__assign({}, shownStatuses), (_a = {}, _a[status] = newShownValue, _a)));
                    },
                }); }) })),
        React.createElement("div", { className: "previous-imports-table-wrap tiny-scrollbars" },
            React.createElement("table", { className: "previous-imports" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { colSpan: 2 }, L('Name')),
                        React.createElement("th", null, L('Status')),
                        React.createElement("th", null, L('Importer')),
                        React.createElement("th", null, L('Description')),
                        React.createElement("th", null, L('Creation date')),
                        React.createElement("th", null, L('Actions')))),
                React.createElement("tbody", null, filteredSortedImportJobs.map(function (importJob) {
                    var _a;
                    var user = users.find(function (u) { return u.id === importJob.creatorId; });
                    var jobName = importJob.title;
                    return (React.createElement("tr", { key: importJob.id },
                        React.createElement("td", { colSpan: 2 },
                            React.createElement("div", { className: "title-wrap", onClick: function () { return openImportJob(importJob); } },
                                React.createElement("img", { src: ExcelIcon }),
                                React.createElement("div", { className: "title" }, jobName))),
                        React.createElement("td", null,
                            React.createElement(ImportJobStatusLabel, { status: importJob.status })),
                        React.createElement("td", null, user !== undefined ? user.firstName : '-'),
                        React.createElement("td", { className: "description" }, (_a = importJob.description) !== null && _a !== void 0 ? _a : '-'),
                        React.createElement("td", null,
                            formatLocaleDate(importJob.createdAt),
                            ' ',
                            importJob.createdAt.toLocaleTimeString()),
                        React.createElement("td", null,
                            React.createElement(ImportActionsMenu, { items: [
                                    // {
                                    //     actionName: L('Edit Labels'),
                                    //     icon: FarseerIcons.Edit,
                                    // },
                                    {
                                        actionName: L('Archive'),
                                        icon: FarseerIcons.Archive,
                                        isDisabled: importJob.status === ImportJobStatus.ARCHIVED,
                                        action: function () { return archiveImportJob(importJob.id); },
                                    },
                                    {
                                        actionName: L('Replace'),
                                        icon: FarseerIcons.Refresh,
                                        isDisabled: importJob.status === ImportJobStatus.ARCHIVED,
                                        action: function () { return replaceImportJob(importJob.id); },
                                    },
                                    {
                                        actionName: L('Download File'),
                                        icon: FarseerIcons.Download,
                                        isDisabled: importJob.source !== ImportJobSource.FARSEER_FILE ||
                                            importJob.farseerFileId === null,
                                        action: function () {
                                            return importJob.farseerFileId !== null
                                                ? downloadFarseerFile(importJob.farseerFileId, importJob.title)
                                                : {};
                                        },
                                    },
                                    {
                                        spacer: true,
                                    },
                                    {
                                        actionName: L('Delete'),
                                        icon: FarseerIcons.Delete,
                                        destructive: true,
                                        action: function () { return openDeleteModal(importJob); },
                                    },
                                ] }))));
                }))))));
}
